/* eslint-disable */
import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';

// insert translationHash from grunt at build time
// @@insertConfigHash
const languageHashObject = {'de':'','es':'','fr':'','it':'','ja':'','ko':'','nl':'','pl':'','pt-br':'','ru':'','tr':'','zh-cn':'','zh-tw':'','id':'','vi':'','in':'','en':''};

const i18nPromise = () => new Promise((resolve, reject) => {

    i18next
        .use(Backend)
        .init({
            lng: CWCONFIG.language,
            debug: false,
            interpolation: {
                prefix: '__',
                suffix: '__',
                escapeValue: false,
            },
            backend: {
                loadPath: `${CWCONFIG.cdn}/lang/${process.env.HASH_VALUE}-${CWCONFIG.language}.json`,
                crossDomain: true,
            },
            nsSeparator: false,
        }, (err) => {

            // initialized and ready to go!
            if (err) {

                reject(err);

            }

            resolve('i18n has loaded');

        });

});

export default i18nPromise;



// WEBPACK FOOTER //
// ./scripts/initi18n.js